/**
 * Billing-specific error presentation, shared by every surface that starts a
 * Stripe Checkout or Billing Portal session (UpgradeModal, Subscription page).
 *
 * The backend answers 503 with `error_code: "BILLING_UNAVAILABLE"` whenever the
 * Stripe SDK call itself fails — misconfigured or mode-mismatched keys, an
 * unactivated account, a Stripe outage. That is an operator problem the user
 * cannot fix by retrying the same click, so it gets its own copy instead of the
 * generic "Could not start checkout" message (which reads as "try again").
 */
export const BILLING_UNAVAILABLE_CODE = 'BILLING_UNAVAILABLE';
export const BILLING_UNAVAILABLE_MESSAGE = "Billing isn't available right now. Please try again later.";

/**
 * Pick the toast copy for a failed checkout / portal request.
 * @param {Object} err - formatted SubscriptionService error ({ message, errorCode, ... })
 * @param {string} fallback - generic copy when the server gave no message
 * @returns {string}
 */
export function billingErrorMessage(err, fallback) {
  if (err?.errorCode === BILLING_UNAVAILABLE_CODE) return BILLING_UNAVAILABLE_MESSAGE;
  return err?.message || fallback;
}
